export default __webpack_public_path__ + "static/media/crow_of_judgement.896e20fa.jpg";